const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/defs/settings.ts';
export const SET_APP_SETTING = 'SET_APP_SETTING';
export const SET_APP_SETTINGS = 'SET_APP_SETTINGS';

export enum AppSetting {
    userName = 'userName',
    quickLoginPassword = 'quickLoginPassword',
}

export type AppSettings = {
    userName: null | string;
    quickLoginPassword: null | string;
};

export const emptyAppSettings: AppSettings = {
    userName: null,
    quickLoginPassword: null,
};

export const defaultAppSettings: AppSettings = {
    userName: null,
    quickLoginPassword: null,
};

export const SET_USER_SETTING = 'SET_USER_SETTING';
export const SET_USER_SETTINGS = 'SET_USER_SETTINGS';

export enum UserSetting {
    askForEnablingBiometricScan = 'askForEnablingBiometricScan',
    enableBiometricScan = 'enableBiometricScan',
    password = 'password',
}

export type UserSettings = {
    askForEnablingBiometricScan: null | boolean;
    enableBiometricScan: null | boolean;
    password: null | string;
};

export const emptyUserSettings: UserSettings = {
    askForEnablingBiometricScan: null,
    enableBiometricScan: null,
    password: null,
};

export const defaultUserSettings: UserSettings = {
    askForEnablingBiometricScan: true,
    enableBiometricScan: false,
    password: null,
};
